import { useContext } from 'react';
import { FlagsmithContext } from '@flagsmith/flagsmith/react';

import { Config } from 'src/config';

export enum EFeatureFlag {
    FEATURE_FLAG_ROUTE = 'feature_flag_route',
    SENTRY_SESSION_REPLAY = 'sentry_session_replay',
    INBOX_GROUP_BY_PROPERTY = 'inbox_group_by_property',
    TRIAGE_INBOX_PAGE = 'triage_inbox_page',
    DOWNLOAD_CSV_FROM_ANALYTICS = 'download_csv_from_analytics',
    CALL_LEAD_WITH_QUO = 'call_lead_with_quo',
    LEAD_FACTS_EXTRACTOR = 'lead_facts_extractor',
    TEAM_AVAILABILITY = 'team_availability',
    PROPERTIES_MAP_VIEW = 'properties_map_view',
    SIMILAR_PROPERTIES = 'similar_properties',
    LIVE_UPDATES = 'live_updates',
    TOUR_TIME_SUGGESTIONS = 'tour_time_suggestions',
};

// The team-availability presence feature is gated by the `team_availability`
// Flagsmith flag, but always enabled on staging and local dev for testing.
export const FORCE_TEAM_AVAILABILITY = Config.isStaging || Config.isLocal;

// The tour-time-suggestions feature is gated by the `tour_time_suggestions`
// Flagsmith flag, but always enabled on local dev for testing.
export const FORCE_TOUR_TIME_SUGGESTIONS = Config.isLocal;

/**
 * Whether a flag is enabled for the current user.
 *
 * Unlike `useFlags`, this tolerates a missing `FlagsmithProvider` and reports the
 * feature as off — tests and Storybook render components outside the app shell,
 * where `useFlags` throws. Re-renders on flag changes still happen, because
 * `FeatureFlaggedApp` subscribes to every flag with `useFlags` above the routes.
 */
export function useIsFeatureEnabled(flag: EFeatureFlag): boolean {
    const flagsmith = useContext(FlagsmithContext);
    return flagsmith?.hasFeature(flag) ?? false;
}
